import PropTypes from "prop-types";
import { Box, Stack } from "@mui/material";

// components
import MobileNavItem from "./MobileNavItem";

const renderItems = ({ depth = 0, items, pathname }) =>
  items.reduce(
    (acc, item) =>
      reduceChildRoutes({
        acc,
        depth,
        item,
        pathname,
      }),
    []
  );

const reduceChildRoutes = ({ acc, depth, item, pathname }) => {
  const checkPath = !!(item.path && pathname);
  const partialMatch = checkPath ? pathname.includes(item.path) : false;
  const exactMatch = checkPath ? pathname === item.path : false;

  if (item.items) {
    acc.push(
      <MobileNavItem
        active={partialMatch}
        depth={depth}
        disabled={item.disabled}
        icon={item.icon}
        key={item.title}
        label={item.label}
        open={partialMatch}
        title={item.title}
      >
        <Stack
          component="ul"
          spacing={0.5}
          sx={{
            listStyle: "none",
            m: 0,
            p: 0,
          }}
        >
          {renderItems({
            depth: depth + 1,
            items: item.items,
            pathname,
          })}
        </Stack>
      </MobileNavItem>
    );
  } else {
    acc.push(
      <MobileNavItem
        active={exactMatch}
        depth={depth}
        disabled={item.disabled}
        external={item.external}
        icon={item.icon}
        key={item.title}
        label={item.label}
        path={item.path}
        title={item.title}
      />
    );
  }

  return acc;
};

const MobileNavSection = ({ items = [], pathname, subheader = "" }) => (
  <Stack
    component="ul"
    spacing={0.5}
    sx={{
      listStyle: "none",
      m: 0,
      p: 0,
    }}
  >
    {subheader && (
      <Box
        component="li"
        sx={{
          color: "var(--nav-section-title-color)",
          fontSize: 14,
          fontWeight: 700,
          lineHeight: 1.66,
          mb: 1,
          ml: 1,
          textTransform: "uppercase",
        }}
      >
        {subheader}
      </Box>
    )}
    {renderItems({ items, pathname })}
  </Stack>
);

MobileNavSection.propTypes = {
  items: PropTypes.array,
  pathname: PropTypes.string.isRequired,
  subheader: PropTypes.string,
};

MobileNavSection.defaultProps = {
  items: [],
  subheader: "",
};

export default MobileNavSection;
